import { Injectable } from '@angular/core';
import { IDobfields } from '../interfaces/dobfields';

@Injectable()
export class DobcalculatorService {
  currentDay = new Date();
  currentYear = this.currentDay.getFullYear();

  constructor() { }
  getDOBFields(): IDobfields[] {
    return [
      { year: this.currentYear - 18 },
      { year: this.currentYear - 19 },
      { year: this.currentYear - 20 },
      { year: this.currentYear - 21 },
      { year: this.currentYear - 22 },
      { year: this.currentYear - 23 },
      { year: this.currentYear - 24 },
      { year: this.currentYear - 25 },
      { year: this.currentYear - 26 },
      { year: this.currentYear - 27 }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/dobcalculator.service.ts